import { createSelector } from 'reselect';

export const getCloseoutCats = createSelector(
  (state) => state.projects.scenes.details.scenes.closeout.data.closeoutCats,
  (closeoutCats) => {
    return closeoutCats;
  }
);

export const getCloseout = createSelector(
  (state) => state.projects.scenes.details.scenes.closeout.data.closeout,
  (closeout) => {
    return closeout;
  }
);

export const getCloseoutContribs = createSelector(
  (state) =>
    state.projects.scenes.details.scenes.closeout.data.closeoutContribs,
  (closeoutContribs) => {
    return closeoutContribs;
  }
);

export const getCurrentPage = createSelector(
  (state) => state.projects.scenes.details.scenes.closeout.data.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getTotal = createSelector(
  (state) => state.projects.scenes.details.scenes.closeout.data.total,
  (total) => {
    return total;
  }
);

export const getPageSize = createSelector(
  (state) => state.projects.scenes.details.scenes.closeout.data.pageSize,
  (pageSize) => {
    return pageSize;
  }
);

export const getCloseoutPercentage = createSelector(
  (state) =>
    state.projects.scenes.details.scenes.closeout.data.closeoutPercentage,
  (closeoutPercentage) => {
    return closeoutPercentage;
  }
);

export const getCloseoutManuals = createSelector(
  (state) => state.projects.scenes.details.scenes.closeout.data.closeoutManuals,
  (closeoutManuals) => {
    return closeoutManuals;
  }
);

export const getCloseoutManualsCurrentPage = createSelector(
  (state) =>
    state.projects.scenes.details.scenes.closeout.data
      .closeoutManualsCurrentPage,
  (closeoutManualsCurrentPage) => {
    return closeoutManualsCurrentPage;
  }
);

export const getCloseoutManualsTotal = createSelector(
  (state) =>
    state.projects.scenes.details.scenes.closeout.data.closeoutManualsTotal,
  (closeoutManualsTotal) => {
    return closeoutManualsTotal;
  }
);

export const getCloseoutManualsPageSize = createSelector(
  (state) =>
    state.projects.scenes.details.scenes.closeout.data.closeoutManualsPageSize,
  (closeoutManualsPageSize) => {
    return closeoutManualsPageSize;
  }
);

export const getCloseoutManual = createSelector(
  (state) => state.projects.scenes.details.scenes.closeout.data.closeoutManual,
  (closeoutManual) => {
    return closeoutManual;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/store/selectors.js